import { parseBooleanParam } from 'helpers/url';

import { getEppoClient } from './client';
import { getAbAutoTestsQuery } from './helpers';
import { buildSubjectAttributes } from './subject';
import type { IEppoAssignmentParams } from './types';

export const getStringSafe = ({ flag, attrs, def }: IEppoAssignmentParams<string>): string => {
    const { aqa, variantName, experiment } = getAbAutoTestsQuery();

    if (aqa && flag === experiment) return variantName || def;

    const c = getEppoClient();
    const subject = buildSubjectAttributes(attrs);

    return c && subject ? c.getStringAssignment(flag, subject, def) : def;
};

export const getJsonSafe = <T extends Record<string, unknown>>({ flag, attrs, def }: IEppoAssignmentParams<T>): T => {
    const { aqa, experimentOptions, experiment } = getAbAutoTestsQuery();

    if (aqa && flag === experiment && experimentOptions) {
        let aqaOptions = undefined;

        try {
            aqaOptions = JSON.parse(experimentOptions);
        } catch (e) {
            console.error('Invalid JSON in options param', e);
        }

        return aqaOptions || def;
    }

    const c = getEppoClient();
    const subject = buildSubjectAttributes(attrs);

    return (c && subject ? c.getJSONAssignment(flag, subject, def) : def) as T;
};

export const getBooleanSafe = ({ flag, attrs, def }: IEppoAssignmentParams<boolean>): boolean => {
    const { aqa, isEnabled, experiment } = getAbAutoTestsQuery();

    if (aqa && flag === experiment) return parseBooleanParam(isEnabled) ?? def;

    const c = getEppoClient();
    const subject = buildSubjectAttributes(attrs);

    return c && subject ? c.getBooleanAssignment(flag, subject, def) : def;
};
